import React, { FC, Fragment, MouseEvent } from 'react';
import { Button, Chip, TableCell, TableRow, Typography } from '@mui/material';
import { User } from 'models/user';
import { Organization } from 'models/organization';
import { useTranslation } from 'react-i18next';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

type DentistDirectoryItemProps = {
    dentist: User;
    onOpenDialog: (dentist: User, clickSource: 'row' | 'button') => void;
};

const DentistDirectoryItem: FC<DentistDirectoryItemProps> = ({ dentist, onOpenDialog }: DentistDirectoryItemProps) => {
    const { t: translate } = useTranslation(['client-directory']);
    const lab = currentOrgVar();
    const localDentistId = dentist.dentistLocalIds?.find((entry) => entry.lab === lab._id?.toString())?.localId;

    const getClinicNames = (clinics: Organization[]) => {
        return clinics?.map((clinic) => clinic.name)?.join(', ');
    };

    const handleDentistClick = () => {
        onOpenDialog(dentist, 'row');
    };
    const createDenthubOrder = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onOpenDialog(dentist, 'button');
    };

    return (
        <Fragment>
            <TableRow hover sx={{ cursor: 'pointer' }} onClick={handleDentistClick}>
                <Fragment>
                    <TableCell sx={{ width: 300 }}>
                        <span>{dentist.fullName}</span>
                        {localDentistId && (
                            <Typography variant="body2" color="text.secondary">
                                {localDentistId}
                            </Typography>
                        )}
                    </TableCell>
                    <TableCell>{dentist.email}</TableCell>
                    <TableCell>{getClinicNames(dentist.clinics || [])}</TableCell>
                    <TableCell>
                        <Chip
                            label={
                                dentist.local
                                    ? translate('client-directory:MY_DENTIST')
                                    : translate('client-directory:DENTHUB_CONNECTED_DENTIST')
                            }
                            size="medium"
                            color={dentist.local ? 'info' : 'secondary'}
                        />
                    </TableCell>
                    <TableCell align="right">
                        <Button onClick={(event) => createDenthubOrder(event)}>
                            {translate('client-directory:CREATE_ORDER')}
                        </Button>
                    </TableCell>
                </Fragment>
            </TableRow>
        </Fragment>
    );
};

export default DentistDirectoryItem;
